/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Request_AccessInputs */

const en_document_request_access = /** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Access`)
};

const id_document_request_access = /** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta Akses`)
};

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const es_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const fr_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const de_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const ja_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const zh_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const ar_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const it_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const ru_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const pt_document_request_access = en_document_request_access;

/** @type {(inputs: Document_Request_AccessInputs) => LocalizedString} */
const ko_document_request_access = en_document_request_access;

/**
* | output |
* | --- |
* | "Request Access" |
*
* @param {Document_Request_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_request_access = /** @type {((inputs?: Document_Request_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Request_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_request_access(inputs)
	if (locale === "es") return es_document_request_access(inputs)
	if (locale === "fr") return fr_document_request_access(inputs)
	if (locale === "de") return de_document_request_access(inputs)
	if (locale === "ja") return ja_document_request_access(inputs)
	if (locale === "zh") return zh_document_request_access(inputs)
	if (locale === "ar") return ar_document_request_access(inputs)
	if (locale === "id") return id_document_request_access(inputs)
	if (locale === "it") return it_document_request_access(inputs)
	if (locale === "ru") return ru_document_request_access(inputs)
	if (locale === "pt") return pt_document_request_access(inputs)
	return ko_document_request_access(inputs)
});